import { render, staticRenderFns } from "./workloadPage.vue?vue&type=template&id=bbd4fbbc&scoped=true&"
import script from "./workloadPage.vue?vue&type=script&lang=js&"
export * from "./workloadPage.vue?vue&type=script&lang=js&"
import style0 from "./less/workloadVue.less?vue&type=style&index=0&id=bbd4fbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd4fbbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbd4fbbc')) {
      api.createRecord('bbd4fbbc', component.options)
    } else {
      api.reload('bbd4fbbc', component.options)
    }
    module.hot.accept("./workloadPage.vue?vue&type=template&id=bbd4fbbc&scoped=true&", function () {
      api.rerender('bbd4fbbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/main/workloadPage/workloadPage.vue"
export default component.exports